import { useState, useEffect } from "react";
import NewBot from "../../Components/Bot/NewBot";
import ChatBotTool from "../chatbottool";
import { useLocation } from "react-router-dom";
import { useProductsContext } from "../../Contexts/SidebarContext";
function CreateChatBot() {
  const { saveNewNodeAndEdges, saveTemplateName } = useProductsContext();
  const location = useLocation();
  const [create, setCreate] = useState<boolean>(true);
  const selectedConnection: any = localStorage.getItem("selectedConnection");
  useEffect(() => {
    if (location?.state != null && location?.state?.create !== true) {
      if (location?.state?.from) {
        saveNewNodeAndEdges([], []);
        saveTemplateName({});
      }
      setCreate(false);
    }
    // React to navigation state only. saveNewNodeAndEdges/saveTemplateName
    // come from SidebarContext unmemoized, so they get a new identity every
    // render; including them would re-fire this effect each render and call
    // the context setters, risking a loop.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location?.state]);

  const onNewBotClick = () => {
    setCreate(false);
    saveNewNodeAndEdges([], []);
    saveTemplateName({});
  };

  return selectedConnection && create ? (
    <NewBot onNewBotClick={onNewBotClick} from={location?.state?.from} />
  ) : (
    <ChatBotTool />
  );
  // return <>{location?.state?.from}</>
}

export default CreateChatBot;
